export default {
  common: {
    pleaseEnterSearchKeywords: "请输入搜索关键词"
  },
  outputProjectList: {
    dateofRegistration: "注册日期",
    updateDate: "更新时间",
    projectName: "项目名称",
    dateofAudit: "审核日期 (年-月)",
    customerName: "客户名称",
    customerEmail: "客户邮箱",
    address: "地址",
    zone: "区域",
    city: "项目所在城市",
    submiter: "提交者",
    projectStatus: "项目状态",
    estimateEcmQutedAmount: "预计ECM报价金额 (美元)",
    expectedOrder: "预计订单日期 (月/年)",
    actualEcmQutedAmount: "实际 ECM报价金额 (美元)",
    actualOrder: "实际订单日期 (月/年)",
    winProbability: "胜率",
    statusRemarks: "项目描述",
    lastUpdateDate: "最近更新时间"
  },
  outputAccountList: {
    activate: "激活",
    registerDate: "注册日期",
    lastLoginDate: "最近登录"
  },
  nomenclature: {
    row0_1: "术语",
    row0_2: "定义",
    row1_1: "AC",
    row1_2: "Air-cooled 的缩写，表示风冷。",
    row2_1: "AHRI",
    row2_2: "Air-Conditioning, Heating, and Refrigeration Institute 的缩写，即美国空调、供热与制冷协会，是对 eCAT 选型中所使用冷机性能评级进行认证的行业组织。",
    row3_1: "风冷冷水机组",
    row3_2: "一种通过冷凝风机直接向环境空气散热的冷水机组，不需要冷却塔或冷却水泵。",
    row4_1: "逼近温差",
    row4_2: "冷却塔出水温度与进入湿球温度之间的温差；在 iECM 中默认值为 3 °C，是冷却水建模中的关键参数。",
    row5_1: "ASIA",
    row5_2: "亚洲区域产品库。主要用于亚洲市场发布的 Carrier 冷机产品组合。",
    row6_1: "基线",
    row6_2: "当前冷站系统，用作对比基准。",
    row7_1: "建筑业态",
    row7_2: "项目设置阶段所选择的建筑类型分类，例如办公室、酒店、医院或其他；该分类可能影响系统默认假设值。",
    row8_1: "CAPEX",
    row8_2: "Capital expenditure 的缩写；指改造项目的前期投资成本。",
    row9_1: "电力碳排放因子",
    row9_2: "单位用电量对应排放的二氧化碳当量质量；iECM 默认值为 0.707 kgCO₂e/kWh，但该数值会因地区和电网能源结构不同而变化。",
    row10_1: "离心式冷水机组",
    row10_2: '一种采用离心压缩机的冷水机组，常用于大型商业和工业场景；在 iECM 中以 "WC–Centri" 表示。',
    row11_1: "冷冻水",
    row11_2: "由冷水机组冷却并在建筑空调系统中循环输送、用于提供制冷的水。",
    row12_1: "CHW",
    row12_2: "Chilled water 的缩写，表示冷冻水。",
    row13_1: "CHWP",
    row13_2: "Chilled water pump 的缩写，表示冷冻水泵。",
    row14_1: "分组",
    row14_2: "在仿真中使用的、具有相似运行条件或天气条件的一组月份。",
    row15_1: "舒适性制冷",
    row15_2: "为建筑内人员热舒适提供的制冷，例如办公室和酒店中的制冷；其区别于工艺制冷。",
    row16_1: "共用总管",
    row16_2: "一种冷却水管路布置方式，所有冷机共用同一组供回水总管，从而使任意冷却塔都可以服务任意冷机。",
    row17_1: "冷却水",
    row17_2: "在冷机冷凝器与冷却塔之间循环，用于将制冷循环中的热量排出的水。",
    row18_1: "COP",
    row18_2: "Coefficient of performance 的缩写，表示性能系数。",
    row19_1: "CT",
    row19_2: "Cooling tower 的缩写，表示冷却塔。",
    row20_1: "CWP",
    row20_2: "Condenser water pump 的缩写，表示冷却水泵。",
    row21_1: "CWS",
    row21_2: "Condenser water supply 的缩写，表示冷却水供水。",
    row22_1: "DB",
    row22_2: "Electrical distribution board 的缩写，表示配电板。",
    row23_1: "性能衰减率",
    row23_2: "由于老化、结垢和磨损导致冷机效率逐年下降的百分比；典型假设值为 好 0.25%、平均 0.50%、低于平均 0.75%、差 1.00%。",
    row24_1: "Digital e-CAT",
    row24_2: "一种基于物理机理和数据驱动的建模工具，用于预测冷机性能。",
    row25_1: "贴现率",
    row25_2: "在 NPV 分析中用于计算未来现金流现值的利率；iECM 默认值为 3%。",
    row26_1: "干球温度",
    row26_2: "由标准温度计测得且不受空气湿度影响的环境空气温度；在 iECM 中用于风冷冷机建模和 cluster 设置的天气曲线。",
    row27_1: "e-CAT 库",
    row27_2: "所有用户均可访问的官方 Carrier e-CAT 冷机数据库。",
    row28_1: "EA",
    row28_2: "Energy audit 的缩写，表示能耗审计。",
    row29_1: "EA Report",
    row29_2: "Energy Audit Report，即在基线预览步骤结束时生成的基线报告，用于记录当前系统性能和可改进机会。",
    row30_1: "eCAT",
    row30_2: "Carrier 的电子产品目录和冷机选型软件。",
    row31_1: "ECM",
    row31_2: "Energy Conservation Measure 的缩写；指拟采用的效率提升措施。",
    row32_1: "ECM Report",
    row32_2: "Energy Conservation Measure Report，即方案报告，包含推荐方案、节能量、财务分析和商业论证。",
    row33_1: "EER",
    row33_2: "Energy efficiency ratio 的缩写，表示能效比。",
    row34_1: "EMEA",
    row34_2: "欧洲、中东和非洲区域产品库。用于欧洲、中东和非洲区域发布的 Carrier 冷机产品组合。",
    row35_1: "递增率",
    row35_2: "对能源、维护、维修和其他运行成本年增长百分比的假设；iECM 默认值为每年 2%。",
    row36_1: "估算 e-CAT",
    row36_2: "当标准 e-CAT 数据不可用时，由 Digital e-CAT 算法估算生成的性能数据。",
    row37_1: "FX rate",
    row37_2: "Foreign exchange rate 的缩写形式，表示汇率。",
    row38_1: "Hz",
    row38_2: "频率单位；在 iECM 中用于定义水泵和冷却塔风机 VFD 的运行频率上下限。",
    row39_1: "iECM",
    row39_2: "Intelligent Energy Conservation Measure 的缩写；是 Carrier 用于冷站优化的能耗审计和改造分析工具。",
    row40_1: "激励与补贴",
    row40_2: "在 NPV 计算中按年度计入的政府或公用事业补贴激励，最长可覆盖 19 年。",
    row41_1: "kgCO₂e",
    row41_2: "用于表示与用电相关温室气体排放量的单位。",
    row42_1: "kW",
    row42_2: "电功率单位，1 kW 等于 1000 W。",
    row43_1: "kWc",
    row43_2: "Kilowatt cooling 的缩写形式，表示冷机或系统的制冷输出功率，单位为千瓦。",
    row44_1: "kWe",
    row44_2: "Kilowatt electrical 的缩写形式，表示冷机或系统部件所消耗的电功率。",
    row45_1: "kWh",
    row45_2: "能耗单位，表示 1 kW 功率持续运行 1 小时所消耗的能量。",
    row46_1: "kWh/RTh",
    row46_2: "Kilowatt-hours per refrigeration ton-hour，表示系统效率的一个指标。",
    row47_1: "制造区域/来源",
    row47_2: "用于确定可选冷机型号库的 Carrier 区域产品组合来源（ASIA、EMEA 或 NAO）。同一冷机系列可能在多个区域提供。",
    row48_1: "多点输入",
    row48_2: "iECM 中的一项数据录入功能，可将当前月份的值复制到其后所有月份，从而加快重复性录入，同时不会覆盖已输入的既有数值。",
    row49_1: "NAO",
    row49_2: "North America Operations（北美运营区）产品库。用于北美区域发布的 Carrier 冷机产品组合。",
    row50_1: "NPV",
    row50_2: "Net Present Value 的缩写；表示项目未来现金流折算到当前时点后的现值。",
    row51_1: "谷时",
    row51_2: "月度整体平均温度。代表一天中较平均的时段，用于对夜间谷时电价时段分配进行加权。",
    row52_1: "运行时段",
    row52_2: "月度基线建模中使用的日期类型分类，例如 工作日、周末 或 全周，用于反映不同的使用模式。",
    row53_1: "运行现场冷机",
    row53_2: "在特定负荷时段（如峰时或谷时）运行的现场冷机。该冷机作为基线性能建模和代理冷机选择的参考设备。",
    row54_1: "自定义库",
    row54_2: "包含用户上传或维护的冷机性能数据的个人冷机库。",
    row55_1: "部分负荷",
    row55_2: "低于额定满负荷容量的运行状态。",
    row56_1: "投资回收期",
    row56_2: "累计年度节省额等于总 CAPEX 投资所需的年数。",
    row57_1: "峰时",
    row57_2: "每月日最高温度的平均值。代表一天中最热的时段，用于对白天峰时电价时段分配进行加权。",
    row58_1: "峰谷电价时段",
    row58_2: "分时电价中的时段划分，其中峰时段电价较高，谷时段电价较低。",
    row59_1: "冷站控制系统",
    row59_2: "用于优化推荐方案冷站运行的自动化与控制基础设施，包括传感器、控制器以及与 BMS 的集成；在 CAPEX 中作为一项投资条目计入。",
    row60_1: "PLR",
    row60_2: "Part load ratio 的缩写，表示部分负荷率。",
    row61_1: "一次泵系统",
    row61_2: "一种冷冻水管路配置方式，由一套水泵同时负责冷机侧和建筑配水环路的水循环。",
    row62_1: "一次-二次泵系统",
    row62_2: "一种冷冻水管路配置方式，设置独立的两组水泵：一次泵服务于冷机，二次泵服务于建筑配水环路，从而实现流量独立控制。",
    row63_1: "工艺制冷",
    row63_2: "为工业或制造工艺提供的制冷，例如数据中心或制药生产；在 iECM 中需要使用 Energy Consumption 基线方法。",
    row64_1: "推荐方案",
    row64_2: "正在与 Baseline 进行比较的推荐新方案。",
    row65_1: "代理冷机",
    row65_2: "从 e-CAT 库中选取的 Carrier 冷机模型，用于代表现场运行冷机进行性能估算和校准。",
    row66_1: "重新配置",
    row66_2: "iECM 的一项功能，允许用户手动覆盖自动冷机选型算法，并在改造方案中为特定运行时段指定特定冷机。",
    row67_1: "参考冷机",
    row67_2: "在某一基线模式下被选作性能基准的冷机；该基线中的所有功率、冷量负荷和性能衰减计算均基于其规格参数。",
    row68_1: "节能改造",
    row68_2: "通过采用更新、更高效的技术，对现有冷站设备进行升级或替换，以降低能耗和运行成本的过程。",
    row69_1: "ROI",
    row69_2: "Return on investment 的缩写；表示年度节省额占总投资的百分比。",
    row70_1: "RT",
    row70_2: "Refrigeration ton 的缩写；一种制冷量单位。",
    row71_1: "RTh",
    row71_2: "Refrigeration ton-hour 的缩写；一种冷量能量单位。",
    row72_1: "电价",
    row72_2: "公用事业公司按每 kWh 收取的电价；在 baseline 配置中，峰时和谷时电价分别录入。",
    row73_1: "VFD",
    row73_2: "Variable Frequency Drive 的缩写；一种通过调节电机转速以匹配负荷的装置。",
    row74_1: "水冷冷水机组",
    row74_2: "一种通过连接冷却塔的冷却水回路排热的冷水机组，在满负荷工况下通常比风冷冷机更高效。",
    row75_1: "WC",
    row75_2: "Water-cooled 的缩写，表示水冷。"
  }
}



// WEBPACK FOOTER //
// ./src/locale/outputFile/zh.js